import { ASSETS } from "@/data/landingData";
import { useLanguage } from "@/context/LanguageContext";

const HeroMedia = () => {
  const { copy } = useLanguage();

  return (
    <div className="hero-media" data-testid="hero-media">
      <div className="hero-image-card" data-testid="hero-image-card">
        <img
          src={ASSETS.pumpHero}
          alt={copy.hero.imageAlt}
          data-testid="hero-image"
          loading="lazy"
        />
        <div className="hero-logo-overlay" data-testid="hero-logo-overlay">
          <img
            src={ASSETS.ennosLogo}
            alt="Ennos logo"
            loading="lazy"
            data-testid="hero-logo-image"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroMedia;